import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError } from 'rxjs';
import { NewRequestFormComponent } from '../components/new-request-form/new-request-form.component';
import { RequestsService } from './requests.service';
import { HandlerSnackbarService } from './handler-snackbar.service';
import { ResourcesService } from './resources.service';

@Injectable({
  providedIn: 'root',
})
export class NewRequestFormService {
  constructor(
    private readonly modalService: NgbModal,
    private readonly appService: ResourcesService,
    private readonly reqService: RequestsService,
    private readonly alertService: HandlerSnackbarService
  ) {}
  

  newReqModal() {
    const modalRef = this.openNewRequestModal();
    this.appService
      .getAllResources()
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return this.alertService.handlerErrorSubscribe(error);
        })
      )
      .subscribe((data: any) => {
        modalRef.componentInstance.categories = data?.sort((a: any, b: any) => {
          if (a.resources)
            a.resources.sort((c: any, d: any) => {
              return c.index < d.index ? -1 : 1;
            });
          if (b.resources)
            b.resources.sort((c: any, d: any) => {
              return c.index < d.index ? -1 : 1;
            });
          return a.index < b.index ? -1 : 1;
        });
      });
  }

  newRequest(formData: any) {
    const modalRef = this.openNewRequestModal();
    modalRef.componentInstance.formData = formData.form;
    modalRef.componentInstance.allowDismiss = false;
    modalRef.componentInstance.selectedApp = {
      id: formData.resourceId,
      name: formData.resourceName,
    };
  }

  openNewRequestModal() {
    const modalRef = this.modalService.open(NewRequestFormComponent, {
      size: 'lg',
      centered: true,
      beforeDismiss: () => modalRef.componentInstance.allowDismiss,
    });
    modalRef.result
      .then((result) => {
        if (result) {
          this.alertService.viewUserMessage();
          this.reqService
            .newRequest(result)
            .pipe(
              catchError((error: HttpErrorResponse) => {
                return this.alertService.viewErrorMessageNewRequest(
                  error,
                  result
                );
              })
            )
            .subscribe((data: any) => {
              this.reqService.getAllPendingRequests();
              this.alertService.viewUserClosingMessage(
                'Richiesta inviata con successo',
                'success-snackbar'
              );
            });
        }
      })
      .catch(() => console.log('Close new request modal'));
    return modalRef;
  }
}
